import React from "react";
import HeroImg from "../assets/hero-img.png";
import Button from "./UI/Button";

const Hero = () => {
  return (
    <div className="flex flex-col items-center">
      <img src={HeroImg} className="w-full" alt="hero-img"></img>
      <div className="flex flex-col items-center px-6">
        <h1 className="text-ocean -mt-12 md:-mt-24 xl:-mt-40 text-lg sm:text-2xl tracking-widest text-center">Your first and last NFT tool</h1>
        <p className="text-white sm:text-2xl mt-12 text-center">The Fastest and First to every project on OpenSea & IMX.</p>
        <p className="text-white sm:text-2xl text-center"> Coinbase coming soon</p>
        <Button className="mt-12" text="Purchase" />
      </div>
    </div>
  );
};

export default Hero;
